import ChartFavoritesDB from 'src/fb/chartFavorites-db';
import { bindDataBaseStore, unbindDataBaseStore } from 'src/utils/FirestoreUtils';

export default {

  /**
   * Fetch chart favorites
   */
  bindChartFavoritesLocal({ clientId }) {
    const chartFavouritesDb = new ChartFavoritesDB();
    const ref = chartFavouritesDb.getQuery([
      ['client', '==', clientId],
      ['scope', '==', 'client'],
      ['package', '==', null],
    ]);
    return bindDataBaseStore({ store: this, property: 'chartFavoritesLocal' }, ref, []);
  }, // bindChartFavoritesLocal()

  bindChartFavoritesRegional({ clinicId }) {
    const chartFavouritesDb = new ChartFavoritesDB();
    const ref = chartFavouritesDb.getQuery([
      ['clinic', '==', clinicId],
      ['scope', '==', 'clinic'],
      ['package', '==', null],
    ]);
    return bindDataBaseStore({ store: this, property: 'chartFavoritesRegional' }, ref, []);
  }, // bindChartFavoritesRegional()

  bindChartFavoritesGlobal() {
    const chartFavouritesDb = new ChartFavoritesDB();
    const ref = chartFavouritesDb.getQuery([
      ['scope', '==', 'global'],
      ['package', '==', null],
    ]);
    return bindDataBaseStore({ store: this, property: 'chartFavoritesGlobal' }, ref, []);
  }, // bindChartFavoritesGlobal()

  unbindChartFavoritesLocal() {
    return unbindDataBaseStore({ store: this, property: 'chartFavoritesLocal' }, []);
  }, // unbindChartFavoritesLocal()

  unbindChartFavoritesRegional() {
    return unbindDataBaseStore({ store: this, property: 'chartFavoritesRegional' }, []);
  }, // unbindChartFavoritesRegional()

  unbindChartFavoritesGlobal() {
    return unbindDataBaseStore({ store: this, property: 'chartFavoritesRegional' }, []);
  }, // unbindChartFavoritesGlobal()

  logout() {
    this.unbindChartFavoritesLocal();
    this.unbindChartFavoritesRegional();
    this.unbindChartFavoritesGlobal();
  }, // logout()

};
